<script>
  import getTranslation, { sprintfo } from '../../utilities/getTranslation';
  import Alert from '../Alert/Alert.svelte';
  import { getMyAccountHost } from './helper';

  export let data, componentInformationKeys;
  const subscriptionCards = data.firstRow.productGroups.length;
  const currentSubscriptionId = data.currentSubscription.metadataId;
  const productName = data.currentSubscription.planName;
  const isFamilyMember = !data.currentSubscription.isPayingUser;

  const productIsOffered = data.firstRow.productGroups.some((subscription) =>
    subscription.products.some(
      (product) =>
        product.metadataId === currentSubscriptionId || product.aka.includes(currentSubscriptionId)
    )
  );

  const infoBoxDescription = () => {
    if (isFamilyMember) {
      return sprintfo(
        getTranslation(
          componentInformationKeys,
          'subscription.currentsubscription.familymember.leaveinfo',
          ''
        ),
        {
          url: `${getMyAccountHost()}/${data.countryIso}/${
            data.language
          }/account/subscription/manage/cancel`,
        }
      );
    } else if (!productIsOffered) {
      return sprintfo(
        getTranslation(
          componentInformationKeys,
          'subscription.currentsubscription.notavailable',
          ''
        ),
        {
          productName,
        }
      );
    }
  };

  const infoText = infoBoxDescription() === '';
</script>

<style lang="scss">
  @use './index' as *;
  @import '../../styles/settings/global';

  .info-box {
    display: flex;
    justify-content: center;

    &-one-card {
      @include mq($from: tabletlandscape) {
        margin-inline-end: spacing(2);
      }
    }

    &-two-cards {
      @include mq($from: tabletlandscape, $until: desktop) {
        padding: 0 3.2rem;
        align-self: center;
      }
    }

    &-three-or-more-cards {
      margin-block-start: spacing(1);

      @include mq($from: tabletlandscape) {
        padding: 0 3.2rem;
        margin-block-end: spacing(2);
      }
    }

    .alert-wrapper {
      max-width: 71.4rem;
    }

    :global(a) {
      font-weight: bold;
    }
  }
</style>

{#if (!infoText && currentSubscriptionId && !productIsOffered) || (!infoText && currentSubscriptionId && isFamilyMember)}
  <div
    class="info-box"
    class:info-box-one-card={subscriptionCards === 1}
    class:info-box-two-cards={subscriptionCards === 2}
    class:info-box-three-or-more-cards={subscriptionCards >= 3}
  >
    <div class="alert-wrapper">
      <Alert type="info">
        {@html infoBoxDescription()}
      </Alert>
    </div>
  </div>
{/if}
